export enum MemberType {
    Primary = 'Primary',
    Supporter = 'Supporter',
    Spouse = 'Spouse',
    DomesticPartner = 'DomesticPartner',
    Dependent = 'Dependent',
    Other = 'Other'
}
